import React from 'react';
import './Equalizer.scss';

const ENTER = 13;
const SPACE = 32;

const onKeyDown = (e, callback) => {
  if ([ENTER, SPACE].includes(e.keyCode)) {
    callback(e);
  }
};

// eslint-disable-next-line react/prop-types
const Equalizer = ({ onClick }) => (
  <div className="equalizer" onClick={onClick} onKeyDown={(e) => onKeyDown(e, onClick)} role="button" tabIndex="0">
    <span className="equalizer__bar" />
    <span className="equalizer__bar" />
    <span className="equalizer__bar" />
    <span className="equalizer__bar" />
  </div>
);

export default Equalizer;
